require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./information-security-and-quality-assurance-information-security-and-quality-assurance-projects-metric-imperial-converter.json") })
        }
      }, "path---information-security-and-quality-assurance-information-security-and-quality-assurance-projects-metric-imperial-converter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---information-security-and-quality-assurance-information-security-and-quality-assurance-projects-metric-imperial-converter!./.cache/json/information-security-and-quality-assurance-information-security-and-quality-assurance-projects-metric-imperial-converter.json
// module id = 2167
// module chunks = 231608221292675